import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = ["message"];
  static values = { delay: Number }; // Delay in milliseconds

  connect() {
    // Default delay if not specified or if 0
    const delay =
      this.hasDelayValue && this.delayValue > 0 ? this.delayValue : 3000; // 3 seconds default

    this.timeout = setTimeout(() => {
      this.dismiss();
    }, delay);
  }

  disconnect() {
    // Clear the timeout if the controller is disconnected before it fires
    // e.g., if the user navigates away quickly or closes the message manually
    clearTimeout(this.timeout);
  }

  // Called manually by close button click or by timeout
  dismiss() {
    // Prevent multiple dismissals (e.g., if timeout and click happen close together)
    if (this.element.dataset.dismissed) return;
    this.element.dataset.dismissed = "true"; // Mark as dismissed

    // Clear the timeout in case it hasn't fired yet (manual close)
    clearTimeout(this.timeout);

    // Add a class to trigger the fade-out animation
    // The animation itself is defined in CSS
    // We rely on the animationend event (specified in HTML) to call remove()
    this.messageTargets.forEach((message) => {
      message.classList.add("animate-fadeOutAction");
    });
  }

  // Called by animationend event listener specified in HTML
  remove() {
    this.element.remove();
  }
}
